import isUrl from './isUrl';

const ERROR_MESSAGE = 'Input is not a valid HTTP URL';

export default function isHttpRule(value: unknown): string | true {
    return isUrl(['http', 'https'], ERROR_MESSAGE, value);
}
